import { Portuguese } from "flatpickr/dist/l10n/pt"
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate"
import moment from 'moment';
import 'moment/locale/pt-br';
import { useRef, useCallback, useEffect } from "react";
export const flatpickrOptions = (name, setFormValue, setTouched, noTime) => {
  moment.locale("pt-br")

  return {
    onClose: (selectedDates, dateStr) => {
      if (dateStr) {
        const dateParse = noTime ? 'DD/MM/YYYY' : "DD/MM/YYYY HH:mm"
        if(setTouched) setTouched(name);
        setFormValue(name, moment(dateStr, "YYYY-MM-DD HH:mm").format(dateParse));
      } 
    },
    mode: "single",
    maxDate: new Date().fp_incr(365),
    locale: Portuguese,
    enableTime: !noTime,
    plugins: [new confirmDatePlugin({})],
    wrap: true,
    disableMobile: true
  };
};

export const flatpickrOptionsInfluencer = (name, setFormValue, setTouched, touched) => {
  moment.locale("pt-br")

  return {
    onClose: (selectedDates, dateStr) => {
      if (dateStr) {
        if(setTouched) setTouched(name);
        setFormValue(name, moment(dateStr, "YYYY-MM-DD").format("DD/MM/YYYY"));
      } 
    },
    mode: "single",
    maxDate: new Date().fp_incr(365),
    locale: Portuguese,
    wrap: true,
    disableMobile: true
  };
};

export const capitalize = (str) => {
  const newString = str.charAt(0).toUpperCase() + str.slice(1)
  return newString;
};

export const abbreviateNumbers = (number, decimals) => {
  if (number >= 1000000) {
      const fixedNumber = (number / 1000000).toFixed(decimals ? decimals : 1);
      return fixedNumber.endsWith('0') ? parseInt(fixedNumber, 10) + 'M' : fixedNumber + 'M';
  } else if (number >= 1000) {
      const fixedNumber = (number / 1000).toFixed(decimals ? decimals : 1);
      return fixedNumber.endsWith('0') ? parseInt(fixedNumber, 10) + 'K' : fixedNumber + 'K';
  } else {
      return number;
  };
};

export const abbreviateName = (name) => {
  const splittedName = name.split(' ');
  const cleanedName = `${splittedName[0]} ${splittedName[1]}`;
  return cleanedName
};

export const branches = [
  'Agência',
  'Alimentícias',
  'Aplicativos',
  'Apostas',
  'AudioVisual',
  'Automotivo',
  'Bebidas',
  'Calçados',
  'Cosméticos',
  'Entretenimento',
  'Farmacias',
  'Instituição de Ensino',
  'Instituição Financeira',
  'Limpeza',
  'Outros',
  'Politicos',
  'Saúde',
  'Supermercado',
  'Time',
  'Transporte',
  'Vestuário'
];

export const curves = ['A', 'B', 'C'];

export const unixDate = (date) => {
  return Number(moment(date, 'YYYY/MM/DD HH:mm').valueOf());
};

export const ensureIntValue = (value) => {
  if((value) % 1 != 0) {
    return Math.round(value)
  }
  return parseInt(value)
};

export const sanitizeCurrencyValue = (val) => {
  const cleanValue = Number(val?.replace(/[a-zA-Z$]+|\./g, "").replace(/,/g, "."));
  return ensureIntValue(cleanValue * 100);
};

export const hasHttpProtocol = (url) => {
  const pattern = /^https?:\/\//;
  return pattern.test(url);
};

export function lastTwelveMonths(monthsList) {
  monthsList = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth();
  const monthsAfter = monthsList.slice(currentMonthIndex + 1);
  const previousOrCurrentMonths = monthsList.slice(0, currentMonthIndex + 1);
  const listaReordenada = monthsAfter.concat(previousOrCurrentMonths);
  return listaReordenada;
}

export const projectType = (type) => {
  const types = {
    CAMPANHA: 'Campanha',
    EVENTOS: 'Eventos',
    PALCO: 'Palco',
    AUDIOVISUAL: 'Audio Visual',
    LIVRO: 'Livro',
    DEMANDA_INTERNA: 'Demanda Interna'
  }
  return types[type] || type;
}

export const useCustomDebounce = (callback, delay) => {
  const timeoutRef = useRef(null);

  const debouncedCallback = useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debouncedCallback;
};

export const parseMentionRawToDisplay = (rawText) => {
  return rawText.replace(/#\[([^\]]+)\([^\)]+\)\]/g, '@$1');
};

export const parseMentionDisplayToRaw = (displayText, mentionedUsers) => {
  let rawText = displayText;
  mentionedUsers.forEach(user => {
    const rawMention = `#[${user.name}(${user.id})]`;
    rawText = rawText.replace(new RegExp(`@${user.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g'), rawMention);
  });
  return rawText;
};